import { Component, Input, OnInit } from '@angular/core';
import get from 'lodash-es/get';
import { RevealContentStates } from '@finder/shared/components/reveal-content/reveal-content.constants';
import { PolylineComponent } from '@finder/shared/components/polyline/polyline.component';
import { AnchorComponent } from '@finder/shared/components/anchor/anchor.component';
import { CommonModule } from '@angular/common';
import { RevealContentComponent } from '@finder/shared/components/reveal-content/reveal-content.component';
import { PictureComponent } from '@finder/shared/components/picture/picture.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'finder-merchandise-group',
    templateUrl: './merchandise-group.component.html',
    styleUrls: ['./merchandise-group.component.scss'],
    standalone: true,
    imports: [
        PolylineComponent,
        AnchorComponent,
        RevealContentComponent,
        CommonModule,
        PictureComponent,
        SafeHtmlPipe
    ]
})
export class MerchandiseGroupComponent implements OnInit {

    @Input() merchandiseData: any;

    minimumLength = 3;
    limit: number;
    showMoreText: string;
    showLessText: string;
    merchandiseCount: number;

    constructor() { }

    ngOnInit() {
        this.limit = this.minimumLength;
        this.showMoreText = get(this.merchandiseData, 'showLinks.showMore.title');
        this.showLessText = get(this.merchandiseData, 'showLinks.showLess.title');
        this.merchandiseCount = get(this.merchandiseData, 'merchandise.length', 0);
    }

    revealContent(state: RevealContentStates) {
        this.limit = state === RevealContentStates.LESS ? this.merchandiseCount : this.minimumLength;
    }
}
